import { useRef } from 'react';
import IframeResizer from 'iframe-resizer-react';

import { URL_CHAT_BOT } from '../../config';
import useChatBot from './useChatBot';

const ChatBot = () => {
  const iframeRef = useRef<IframeResizer.IFrameObject>(null);

  const LANG = 'ES';
  const srcIframeChat = `${URL_CHAT_BOT}/?dc_language=${LANG}`;

  const { onResized, displayIframe } = useChatBot();

  return (
    <IframeResizer
      id="obchat"
      forwardRef={iframeRef}
      heightCalculationMethod="bodyOffset"
      checkOrigin={[URL_CHAT_BOT]}
      log={false}
      autoResize={false}
      sizeWidth
      src={srcIframeChat}
      onResized={onResized}
      bodyBackground="transparent"
      style={{ minHeight: '100px', minWidth: '140px', position: 'fixed', right: "10px", bottom: '5px', zIndex:990, display: displayIframe }}
    />
  );
};

export default ChatBot;
